import AbmMsjsVerifcaBuscador from "../../components/textos/AbmMsjsVerifcaBuscador/AbmMsjsVerifcaBuscador";

export const configTable = {
    urls: [
        "/Texto/GetByIdTipoTexto/2?Pagina=1&RegistrosPorPagina=-1", // GET
        "/Texto", // POST 
        "/Texto", // PUT
        "/Texto" // DELETE
    ],
    grid: {
        columnConfig: ["id","nombre", "descripcion"], 
        searchField: ["nombre", "id", "descripcion"]
    },
    Abm: AbmMsjsVerifcaBuscador,
    textSize: 10
}